/**
 * Back-in-stock "notify me" button (see snippets/cx-notify-me.liquid).
 * Shows the button only while the selected variant is sold out and keeps the
 * sign-up tags in sync with the selected variant.
 */
(function () {
  if (customElements.get('cx-notify-me')) return;

  var STORAGE_KEY = 'cx-notify-posted';

  class CxNotifyMe extends HTMLElement {
    connectedCallback() {
      this.block = this.closest('.buy-buttons-block');
      this.toggleButton = this.querySelector('[data-cx-toggle]');
      this.panel = this.querySelector('[data-cx-panel]');
      this.form = this.querySelector('form');
      this.tagsInput = this.querySelector('[data-cx-tags]');
      this.label = this.querySelector('[data-cx-label]');
      this.success = this.querySelector('[data-cx-success]');

      this.abortController = new AbortController();
      var signal = this.abortController.signal;

      this.toggleButton && this.toggleButton.addEventListener('click', this.onToggle, { signal: signal });
      this.form && this.form.addEventListener('submit', this.onSubmit, { signal: signal });

      var target = this.closest('.shopify-section, dialog, product-card') || document;
      target.addEventListener('variant:update', this.onVariantUpdate, { signal: signal });

      this.restorePosted();
    }

    disconnectedCallback() {
      this.abortController && this.abortController.abort();
    }

    onToggle = () => {
      this.setOpen(this.panel.hidden);
    };

    setOpen(open) {
      if (!this.panel) return;
      this.panel.hidden = !open;
      this.toggleButton && this.toggleButton.setAttribute('aria-expanded', String(open));
      if (open) {
        var input = this.panel.querySelector('input[type="email"]');
        input && input.focus();
      }
    }

    onVariantUpdate = (event) => {
      var detail = event.detail || {};
      var data = detail.data || {};

      if (data.newProduct) {
        this.dataset.productId = data.newProduct.id;
      } else if (data.productId && data.productId !== this.dataset.productId) {
        return;
      }

      var variant = detail.resource;
      var soldOut = !!variant && variant.available === false;

      if (variant) {
        this.dataset.variantId = variant.id;
        this.dataset.variantTitle = variant.title || '';
        this.updateTags();
      }

      this.setSoldOut(soldOut);
      this.setOpen(false);
      if (this.success) this.success.hidden = true;
      if (this.toggleButton) this.toggleButton.hidden = false;
    };

    setSoldOut(soldOut) {
      this.hidden = !soldOut;
      if (this.block) this.block.toggleAttribute('data-cx-soldout', soldOut);
    }

    updateTags() {
      var label = this.dataset.productTitle || '';
      var variantTitle = this.dataset.variantTitle;
      if (this.dataset.defaultVariant !== 'true' && variantTitle && variantTitle !== 'Default Title') {
        label += ' - ' + variantTitle;
      }

      if (this.label) this.label.textContent = label;
      if (this.tagsInput) {
        var tagLabel = label.replace(/,/g, ' ').slice(0, 200);
        this.tagsInput.value =
          'restock-notify, restock-variant-' + this.dataset.variantId + ', restock: ' + tagLabel;
      }
    }

    onSubmit = () => {
      try {
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({ productId: this.dataset.productId, variantId: this.dataset.variantId })
        );
      } catch (e) {}
    };

    restorePosted() {
      var stored = null;
      try {
        stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      } catch (e) {}
      if (!stored || stored.productId !== this.dataset.productId) return;

      var params = new URLSearchParams(window.location.search);
      var errors = this.querySelector('[data-cx-errors]');

      if (params.get('customer_posted') === 'true' && !errors) {
        this.hidden = false;
        if (this.toggleButton) this.toggleButton.hidden = true;
        if (this.panel) this.panel.hidden = true;
        if (this.success) this.success.hidden = false;
        try {
          sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
      } else if (errors && !this.hidden) {
        errors.hidden = false;
        this.setOpen(true);
      }
    }
  }

  customElements.define('cx-notify-me', CxNotifyMe);
})();
